<button
  type="button"
  mat-icon-button
  class="tema"
  [attr.aria-label]="tema.getToggleLabel()"
  [matTooltip]="tema.getToggleLabel()"
  (click)="tema.toggleTheme()"
>
  <mat-icon>{{ tema.isDarkThemeActive() ? 'light_mode' : 'dark_mode' }}</mat-icon>
</button>
